import styled from 'styled-components';
import { ifProp, palette, theme } from 'styled-tools';
import { BsTrash } from 'react-icons/bs';
import Button from '../../components/Button';

export const TooltipContent = styled.span`
  display: block;
  max-width: 240px;
  line-height: 1.5;
  font-size: ${theme('fontSize.xxs')};
  word-break: break-all;
`;

export const Title = styled.h2`
  font-size: ${theme('fontSize.md')};
  font-weight: ${theme('fontWeight.bold')};
  transition: ${theme('transition')};
  color: ${palette('titleCard')};
  margin-bottom: 10px;
`;

export const ErrorText = styled.span`
  color: ${palette('danger')};
`;

export const AddInput = styled.div`
  display: flex;
  place-content: center;
  place-items: center;
  gap: 0 4px;
`;

export const TemplateList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TemplateListContainer = styled.div`
  border-right: 1px solid ${palette('bgHoverGrey')};
  display: flex;
  flex-direction: column;
  padding: ${theme('spacing.md')} ${theme('spacing.sm')};
  row-gap: 14px;
  height: calc(100vh - 150px);
`;
export const EmptyTemplates = styled.div`
  color: ${palette('textContrast2')};
  text-align: center;
  margin-bottom: ${theme('spacing.md')};
`;
export const AddTemplateButton = styled(Button)`
  display: flex;
  flex-direction: row;
  row-gap: 4px;
  place-content: center;
  place-items: center;
  align-items: center;
`;

export const DeleteTemplateIcon = styled(BsTrash)`
  width: 20px;
`;

export const TemplateName = styled.span`
  flex: 1;
  color: ${palette('titleCard')};
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

type TemplateItemProperties = {
  isActive: boolean;
};
export const TemplateItem = styled.button<TemplateItemProperties>`
  display: flex;
  place-items: center;
  border: 0;
  cursor: pointer;
  text-align: left;
  font-weight: ${ifProp('isActive', 'bold', 'normal')};
  padding-top: 12px;
  padding-bottom: 12px;
  background-color: ${ifProp(
    'isActive',
    palette('colorStepbarLine'),
    palette('bgBodyTransparent')
  )};
  border-left: 2px solid
    ${ifProp('isActive', palette('primary'), palette('bgBodyTransparent'))};

  &:hover,
  &:active {
    background-color: ${palette('bgCardBoardDragging')};
    border-left: 2px solid ${palette('primary')};
  }

  > svg {
    visibility: hidden;
  }
  &:hover > svg {
    visibility: visible;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 4px;
  &:not(:first-child) {
    margin-top: 20px;
  }
  font-weight: ${theme('fontWeight.bold')};
`;

export const FormContainer = styled.div`
  padding: 20px 20px 20px 10px;
`;
